import {Tooltip} from 'platform/components';
import {Icon, ThemeIconKey} from 'platform/foundation';
import styled from 'styled-components';

type Props = {
  icon: ThemeIconKey;
  label: string;
  isActive: boolean;
  onClick: () => void;
  'data-testid': string;
};

export function SourcingViewChoice(props: Props) {
  return (
    <Tooltip label={props.label}>
      <ViewChoiceButton
        type="button"
        aria-label={props.label}
        aria-pressed={props.isActive}
        $active={props.isActive}
        onClick={props.onClick}
        data-testid={props['data-testid']}
      >
        <Icon
          value={props.icon}
          size={4}
          color={props.isActive ? 'general.accent' : 'palettes.neutral.60.100'}
        />
      </ViewChoiceButton>
    </Tooltip>
  );
}

const ViewChoiceButton = styled.button<{$active: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({theme}) => theme.getSize(8)};
  height: ${({theme}) => theme.getSize(8)};
  border: 1px solid ${({theme, $active}) => ($active ? theme.colors.general.accent : 'transparent')};
  border-radius: ${({theme}) => theme.radii.small};
  background: ${({theme, $active}) =>
    $active ? theme.colors.palettes.neutral[20][100] : theme.colors.general.white};
  cursor: pointer;

  &:hover {
    background: ${({theme}) => theme.colors.palettes.neutral[30][100]};
  }

  &:active {
    background: ${({theme}) => theme.colors.palettes.neutral[40][100]};
  }

  &:focus-visible {
    outline: ${({theme}) => theme.outline.default} ${({theme}) => theme.colors.general.accent};
    outline-offset: ${({theme}) => theme.outline.offset};
  }
`;
